export default __webpack_public_path__ + "1d5a02831f84e779b63a911ce3007f7e.svg";